import { ChangeDetectionStrategy, Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { HelpdeskObject } from '../../../helpdesk/helpdesk.datamodel';
import { HelpdeskComponent } from '../../../helpdesk/helpdesk.component';
import { CoreService } from '../../store/core.service';
import { LoginService } from '../../../login/store/login.service';
import { BuildInfo } from '../../../../environments/build-info';
import { UserService } from '../../../user/user.service';
import { UserProfile } from '../../../user/user.datamodel';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Component representing the Preferences dropdown of App Store.
 * the Preference dropdown contains : My account, Preferences, My Apps.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "ama-ng-preferences",
  standalone: true,
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownItem
  ],
  templateUrl: "preferences.component.html"
})
export class PreferencesComponent implements OnInit, OnDestroy {
  preferenceLabel!: string;

  private navigation: any;
  private user!: UserProfile;
  private readonly subscriber: Subscription;

  constructor(
    private readonly coreService: CoreService,
    private readonly loginService: LoginService,
    private readonly userService: UserService,
    private readonly modalService: NgbModal
  ) {
    this.subscriber = this.coreService
      .navigation$
      .subscribe(newNavigation => this.navigation = newNavigation);
  }

  ngOnInit() {
    this.user = this.userService.getUser();
    if (
      !this.user.firstName ||
      !this.user.lastName
    ) {
      this.preferenceLabel = this.user.userId.toUpperCase();
    } else {
      this.preferenceLabel =
        `${this.user.firstName} ${this.user.lastName.toUpperCase()}`;
    }
  }

  ngOnDestroy() {
    this.subscriber.unsubscribe();
  }

  /**
   * Alert if navigation is blocked before log out.
   */
  handleLogout() {
    const navigationBlocked = this.navigation.navigationBlocked;
    if (Object.keys(navigationBlocked).length === 0) {
      this.loginService.aasLogoutAction();
      this.loginService.logout();
    } else {
      const newAlert = Object.assign({}, navigationBlocked);
      newAlert.actions = navigationBlocked.actions.slice();
      const discardAction = Object.assign({}, newAlert.actions[0]);
      discardAction.callback = () => {
        this.loginService.logout();
      };
      newAlert.actions[0] = discardAction;
      this.coreService.displayAlert(newAlert);
    }
  }

  /**
   * Alert displaying the jsession ID and user infos
   */
  displayHelpdeskInfos() {
    const helpdesk: HelpdeskObject = {
      title: "Helpdesk",
      infos: {
        "Username": this.user.userId,
        "Organization": this.user.organizationId,
        "Office ID": this.user.officeId,
        "Language": this.user.language ? this.user.language : "EN"
      },
      jsessionId: this.user.jsessionId,
      version: BuildInfo.version
    };
    this.modalService.open(HelpdeskComponent, {
      size: "xl",
      injector: Injector.create({
        providers: [
          { provide: HelpdeskObject, useValue: helpdesk },
        ]
      })
    });
  }
}
